
import { ExcelMapperConfig } from "@/utils/excel-mapper/excel-mapper-config";
import AppEditColumn from "./ExcelMapperSettingsEditColumn.vue";
import Vue from "vue";
import { ExcelMapperCol } from "@/utils/excel-mapper/excel-mapper-col";

export default Vue.extend({
	data(){
		return {
			toEditColumn: null as null | ExcelMapperCol
		};
	},
	props: {
		settings: {
			type: Object as ()=>ExcelMapperConfig,
			required: true
		},
		knownHeaders: {
			type: Array as ()=>string[],
			required: true
		},
		allowedOutputHeaders: {
			type: Array as ()=>string[],
			required: true
		}
	},
	methods: {
		addColumn(){
			this.toEditColumn = new ExcelMapperCol();
		},
		editColumn(col:ExcelMapperCol){
			this.toEditColumn = col;
		},
		deleteColumn(i:number){
			this.settings.Cols.splice(i,1);
		},
		onEditColInput(value:ExcelMapperCol){
			let i = this.settings.Cols.findIndex(c=>c.uid == value.uid);
			if (i == -1) {
				this.settings.Cols.push(value);
			}else{
				this.$set(this.settings.Cols, i, value);
			}
		}
	},
	components: {
		AppEditColumn
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
